import React from "react"
import services from "../../services"
import { withRouter, Route } from "react-router-dom"
import Lang from "../../lang"
import SearchFilter from "../filters/SearchFilter"
import TitleBar from "../common/title_bar"
import $ from "jquery"
import TlkTable from "../tlelrik/table/tlkTable"
import queryString from "query-string"
import AccountMovement from "./AccountMovement"
import AccountListing from "./AccountListing"
import { Button } from "@progress/kendo-react-buttons"

const columnKeyMap = {
    //idEntidade: "Número",
    //fregusianame: "Freguesia",
    //designacao: "Instalação Vínica",
    nome: "Entidade",
    nomeEntreposto: "Entreposto",
    tipoInstalacao: "Tipo instalação",
    idInstalacaoVinica: "Número de instalação",
    estado: "Estado",
    saldoTotal: "Saldo Total",
    saldoGranel: "Não certificado",
    saldoApto: "Indisponível granel",
    saldoEngarrafado: "Indisponível engarrafado",
    comercializado: "Comercializado"
}

const filters = {
    Tabs: {
        NIF: [
            {
                key: "nif",
                displayKey: "procurar por nif",
                inputType: "text",
            },
        ],
        // Parcela: [
        //   {
        //     key: 'pontuacao',
        //     displayKey: "pontuação",
        //     inputType: "text"
        //   },
        //   {
        //     key: 'numparc',
        //     displayKey: "Nº Parcela IVDP",
        //     inputType: "text"
        //   },
        //   {
        //     key: 'numparant',
        //     displayKey: " Nº Parcela CD",
        //     inputType: "text"
        //   },
        // ],
        // Geocódigo: [
        //   {
        //     key: 'countryName',
        //     displayKey: "Concelho",
        //     inputType: "text"
        //   },
        //   {
        //     key: 'parishName',
        //     displayKey: "Freguesia",
        //     inputType: "text"
        //   },
        //   {
        //     key: 'geocod',
        //     displayKey: "Geocódigo",
        //     inputType: "text"
        //   }
        // ],
        // "Ficha de exploração": [
        //   {
        //     key: 'anoplantacao',
        //     displayKey: "Ano de plantação",
        //     inputType: "text"
        //   }
        // ]
    },
    checkbox: [
        // {
        //   key: 'Explorer',
        //   displayKey: "Exploradora",
        //   inputType: "radio"
        // },
        // {
        //   key: 'Owner',
        //   displayKey: "Proprietária",
        //   inputType: "radio"
        // },
        // {
        //   key: 'Explorer/Owner',
        //   displayKey: "Ambos",
        //   inputType: "radio"
        // },
    ],
}

class ContaOperation extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            entityGrid: "",
            showSearchMsg: false,
            totalcount: 0,
            entity_list_object: {},
            customfilters: {},
            tlkfilter: {},
            date: new Date(),
        }
    }

    componentDidMount() {
        $(window).scrollTop(0)
    }

    componentDidUpdate(proProp) {
        if (proProp.date !== this.props.date) {
            this.setState({
                date: new Date(),
            })
        }
    }

    getLangFile = () => {
        Lang.getJSON.getJSONFile()
    }

    handleFilter = (data) => {
        console.log("fffffffff", data)
    }

    createTable = async () => {
        const columnList = Object.keys(columnKeyMap).map((key) => ({
            field: columnKeyMap[key],
            columnMenuType: "checkbox",
        }))
        const actionbuttons = {
            CommonRedirection: "Detalhes da instalação do vinho",
        }
        const entityGrid = (
            <TlkTable
                date={new Date()}
                sendDatatoTlkTable={(filter) => this.sendDataToGrid(filter)}
                list={this.state.data}
                modulename={"Conta Corrente"}
                notAction={false}
                notGroup={true}
                actionbuttons={actionbuttons}
                columnlist={columnList}
                ActionPerform={(action, id) => this.ActionPerform(action, id)}
                // selection={ true }
                // selectionChange={ (e) => this.selectionChange(e) }
            />
        )
        await this.setState({ entityGrid })
    }

    selectionChange(selection) {
        const data = [...this.state.data]
        data.some((item, index) => {
            if (selection.dataItem.Entidade === item.Entidade) {
                data[index].selected = !item.selected
                return true
            }
            return false
        })
        this.setState({ data }, async () => {
            await this.createTable()
            const queryParams = queryString.stringify({
                entityId: selection.dataItem.Entidade,
            })
            this.props.history.push(
                `/conta_corrente/tabs_view/account?${queryParams}`
            )
        })
    }

    getFilters(filters) {
        if (!this.props.match.isExact) {
            this.props.history.push("/conta_operações")
        }
        console.log("filter", filters)
        this.setState(
            {
                customfilters: filters,
                totalcount: 0,
                showSearchMsg: false,
                entityGrid: null,
            },
            () => {
                if (
                    filters &&
                    (Object.keys(filters.filters).length > 0 ||
                        Object.keys(filters.filterCheckbox).length > 0)
                ) {
                    this.sendDataToGrid({})
                }
            }
        )
    }

    makeAllFilters = () => {
        const customFilters = { ...this.state.customfilters }
        return {
            Filters: {
                entityId: +customFilters.filters.nif
                    ? +customFilters.filters.nif
                    : +customFilters.filters.entityIdFilter || null,
                installationNo: customFilters.filters.Installation,
            },
            FiltersIn: null,
            FiltersLike: null,
            SortBy: "",
            IsSortTypeDESC: true,
            IsPagination: false,
            Page: 2,
            PageSize: 2,
        }
    }

    sendDataToGrid = async (tlkFilter) => {
        let { customfilters } = this.state
        if (
            customfilters &&
            Object.keys(customfilters.filters).length === 0 &&
            Object.keys(customfilters.filterCheckbox).length === 0
        ) {
            return
        }
        const filters = this.makeAllFilters(tlkFilter)
        const response = await services.apiCall.requestApi(
            "InstalacaoVinica/GetInstalacoesVinicas",
            filters,
            "post"
        )

        if (response && response.length > 0) {
            // const data = response.map((entity, index) => ({
            //   ...Object.keys(columnKeyMap).reduce((acc, key) => {
            //     acc[columnKeyMap[key]] = entity[key]
            //     return acc;
            //   }, {}),
            //   selected: false,
            // }));
            const data = response.map((entity, index) => ({
                ...entity,
                ...Object.keys(columnKeyMap).map((key) => {
                    if(key === "saldoTotal"){
                        entity[columnKeyMap[key]] = Number(Number(entity["saldoGranel"] ? entity["saldoGranel"] : "") + 
                        Number(entity["saldoApto"] ? entity["saldoApto"] : "") + 
                        Number(entity["saldoEngarrafado"] ? entity["saldoEngarrafado"] : "") +
                        Number(entity["comercializado"] ? entity["comercializado"] : ""))
                    }
                    else if(key === "saldoGranel" ||
                    key === "saldoApto" ||
                    key === "saldoEngarrafado"||
                    key === "comercializado") {
                        entity[columnKeyMap[key]] = entity[key] || "0"
                    }
                    else {
                        entity[columnKeyMap[key]] = entity[key]
                    }
                }),
                selected: false,
            }))
            this.setState(
                {
                    data,
                    showSearchMsg: false,
                    totalcount: window.localStorage.getItem("table_total"),
                },
                () => this.createTable()
            )
        } else {
            this.setState({
                showSearchMsg: true,
            })
        }
    }

    /*  Para realizar a ação com base na seleção da tabela  */
    ActionPerform = async (action, row) => {
        // TODO: Rohit — Export data from grid
        if (action === "Detalhes da instalação do vinho") {
            console.log("row is here, ", row)
            const queryParams = queryString.stringify({
                entityId: row.idEntidade,
                IDInstalacaoVinica: row.idInstalacaoVinica,
            })
            this.props.history.push(`/conta_operações/accounts?${queryParams}`)
            // });
        }
    }

    backToSearch = () => {
        this.props.history.push("/conta_operações")
    }

    /*  Para renderizar o conteúdo html da página   */
    render() {
        return (
            <div className="inner-container">
                <div className="outer-space">
                    <TitleBar
                        title="Conta Corrente Vínica"
                        prevPageLink={"/conta_corrente"}
                        prevPageName={"Operações"}
                        logo="contacorrente"
                    />
                </div>
                <div className="container-fluid">
                    {this.props.location.pathname === "/conta_operações" ? (
                        <SearchFilter
                            searchplaceholder="Pesquisa por NIF ou designação"
                            installationNumber={true}
                            date={this.state.date}
                            filters={filters}
                            moduleType="Conta"
                            data={this.state.data}
                            handleFilter={(data) => this.handleFilter(data)}
                            getFilter={(data) => this.getFilters(data)}
                        />
                    ) : (
                        <Button
                            className="k-button mr-2 k-primary btn-ivdp-secondary btn-theme remoove mt-2text-danger"
                            onClick={() => this.backToSearch()}
                        >
                            Voltar para Pesquisar
                        </Button>
                    )}
                    {(this.props.location.pathname ===
                        "/conta_operações/accounts" ||
                        this.props.location.pathname ===
                            "/conta_operações/movements") && (
                        <Button
                            className="mr-2 btn-ivdp-primary btn-theme k-primary"
                            onClick={() => window.history.back()}
                        >
                            Voltar
                        </Button>
                    )}

                    <div className="table-section custom-k-grid pt-3">
                        {this.props.match.isExact && (
                            <>
                                {
                                    <div
                                        className={
                                            this.state.data &&
                                            this.state.data.length
                                                ? ""
                                                : "tlkwodata"
                                        }
                                    >
                                        {this.state.totalcount > 0 && (
                                            <h3>
                                                {" "}
                                                A pesquisa retornou{" "}
                                                {
                                                    this.state.totalcount
                                                } registos{" "}
                                            </h3>
                                        )}
                                        <div className="table-responsive">
                                            {this.state.entityGrid}
                                        </div>
                                    </div>
                                }
                                {this.state.totalcount === 0 && (
                                    <div className="searct-found">
                                        <img
                                            className="img-fluid"
                                            src="imgs/data-contacorrente.png"
                                            alt=""
                                        />
                                        {this.state.showSearchMsg ? (
                                            <p className="font-14">
                                                Sem resultados
                                            </p>
                                        ) : (
                                            <h3>
                                                Pesquise uma entidade para apresentação de mais informações
                                            </h3>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    {!this.props.match.isExact && (
                        <Route
                            path={`${this.props.match.path}/movements`}
                            component={AccountMovement}
                        />
                    )}
                    {!this.props.match.isExact && (
                        <Route
                            path={`${this.props.match.path}/accounts`}
                            component={AccountListing}
                        />
                    )}
                </div>
            </div>
        )
    }
}

export default withRouter(ContaOperation)
